export default __webpack_public_path__ + "static/media/delete-all.a36a53b8.svg";